export default "__VITE_PUBLIC_ASSET__80cad10b__"